module.exports = __webpack_public_path__ + "static/img/catRobotica.a199612.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/catRobotica.svg
// module id = WfTz
// module chunks = 0